import { render, staticRenderFns } from "./TeamData.vue?vue&type=template&id=22c1649f"
import script from "./TeamData.vue?vue&type=script&lang=js"
export * from "./TeamData.vue?vue&type=script&lang=js"
import style0 from "./TeamData.vue?vue&type=style&index=0&id=22c1649f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c1649f')) {
      api.createRecord('22c1649f', component.options)
    } else {
      api.reload('22c1649f', component.options)
    }
    module.hot.accept("./TeamData.vue?vue&type=template&id=22c1649f", function () {
      api.rerender('22c1649f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/IncubatorApply/TeamData.vue"
export default component.exports